// @flow

import { loader } from 'graphql.macro';

export const insightsSuspiciousNewDomainsQuery = loader('./queries/InsightsSuspiciousNewDomainsQuery.graphql');
export const suspiciousNewDomainQuery = loader('./queries/SuspiciousNewDomainsQuery.graphql');

export type SuspiciousDomainCountsByDate = { date: number, keys: string[], values: number[] };
